import { styled } from 'styled-components';
import { StyledLabel } from '../Label';
export const Wrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: ${({ withLabelMargin }) => withLabelMargin && '16px'};
`;
export const RadioContainer = styled.label `
  display: inline-flex;
  align-items: flex-start;
  gap: 8px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

  & ${StyledLabel} {
    color: ${({ theme: { colors }, disabled }) => (disabled ? colors.grey100_2 : colors.black_1)};
    margin: 0;
  }
`;
export const RadioWrapper = styled.div `
  position: relative;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
`;
export const StyledRadio = styled.div `
  position: relative;
  z-index: 1;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  width: 100%;
  height: 100%;
  background-color: ${({ checked, disabled, theme: { colors } }) => {
    if (disabled)
        return checked ? colors.grey30_3 : colors.grey05_3;
    return checked ? colors.main : colors.grey00_1;
}};
  border: 1px solid
    ${({ checked, disabled, theme: { colors } }) => {
    if (disabled)
        return colors.grey30_3;
    return checked ? colors.main : colors.grey70_1;
}};
  border-radius: 50%;
  transition: all 100ms;

  &::after {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${({ checked, disabled, theme: { colors } }) => {
    if (!checked)
        return 'transparent';
    if (disabled)
        return colors.grey01_2;
    return colors.grey00_2;
}};
  }
`;
export const HiddenRadio = styled.input `
  position: absolute;
  border: 0;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  top: 0;
  left: 0;
  z-index: 1;
  opacity: 0;
  cursor: inherit;

  &:checked:not(:disabled):hover + ${StyledRadio} {
    background-color: ${({ theme }) => theme.colors.mainDark};
    border-color: ${({ theme }) => theme.colors.mainDark};
  }

  &:not(:checked):not(:disabled):hover + ${StyledRadio} {
    border-color: ${({ theme }) => theme.colors.grey100_1};
  }

  &:focus-visible,
  &:focus {
    & + ${StyledRadio} {
      outline: none;
      ${({ theme }) => theme.shadows.focus}
    }
  }
`;
export const RadioLabel = styled.span `
  ${({ theme }) => theme.typography.textMedium};
  color: ${({ theme: { colors }, disabled }) => (disabled ? colors.grey100_2 : colors.black_1)};
`;
